import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PromoModalComponent } from '../shared/promo-modal/promo-modal.component';
import { Dialog } from '@angular/cdk/dialog';
import { DialogInteractionService, EventInteractionService, NgxDialogButtonActionTypeENUM, NgxDialogConfig } from '@mare-common/ngx-mare-common';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserCompanyService } from './userCompany.service';

declare var window: any;

export interface PromoContent {
  promo_title: string;
  promo_text: string;
  destination_state: string;
}

@Injectable({
  providedIn: 'root'
})
export class PromoService {
  
userNotifications: any;
  constructor(
    public dialog: MatDialog,
    private dialogInteractionService: DialogInteractionService,
    private eventInteractionService: EventInteractionService,
    private translateService: TranslateService,
    private userCompanyService: UserCompanyService,
    private router: Router,
  ) {

  }

  openReportModal(options: PromoContent, eventAction: {event: string, data: any}) {
    console.log(options);
    let that = this;
    let dataContent: NgxDialogConfig = {
      title: options.promo_title ?? null,
      content: options.promo_text,
      width: '720px',
      buttons: [
        {
          label: 'Non adesso',
          actionType: NgxDialogButtonActionTypeENUM.CUSTOM,
        },
        {
          label: 'Continua',
          color: 'primary',
          actionType: 'CUSTOM',
          onClick() {
            return new Promise((resolve) => {
              that.eventInteractionService.publishData(eventAction);
              resolve(true);
            });
          }
        }
      ]
    }
    this.dialogInteractionService.openDialog(dataContent);
  }
  
  openPromoModal(options: PromoContent[]) {
    console.log('options in promomodal', options);
    this.checkIfAlreadyNotified(options).then((new_options) => {
      console.log('new_options', new_options);
      if (!new_options || new_options.length == 0){
        return;
      }
      options = new_options;
   
        if (Array.isArray(options) && options.length == 1) {
          let that = this;
          let content = '';
          this.translateService.get(options[0].promo_text).subscribe((res: string) => {
            content = res;
          });

          let dataContent: NgxDialogConfig = {
            title: options[0].promo_title ?? null,
            subtitle: 'Una novità prima di iniziare!',
            content: content,
            width: '720px',
            buttons: [
              {
                label: 'Non adesso',
                actionType: NgxDialogButtonActionTypeENUM.CUSTOM,
                onClick() {
                  return new Promise((resolve) => {
                    // that.eventInteractionService.publishData({ event: 'hide_notification' , data: that.checkpage});
                    that.sendUserAction('user_experience_info', options[0].destination_state);
                    resolve(true);
                  });
                }
              
              },
              {
                label: 'Vai alla pagina',
                color: 'primary',
                actionType: 'CUSTOM',
                link: options[0].destination_state,
                
                onClick() {
                  return new Promise((resolve) => {
                    // that.eventInteractionService.publishData({ event: 'hide_notification' , data: that.checkpage});
                    that.router.navigateByUrl(environment.routingBasePath + '/' + options[0].destination_state);
                    resolve(true);
                  });
                }

              }
            ]
          }
          

          this.dialogInteractionService.openDialog(dataContent);
        } else if (Array.isArray(options) && options.length > 1) {
          let that = this;
          let content = '';
          let dataContent: NgxDialogConfig = {
            subtitle: 'Una novità prima di iniziare!',
            width: '720px',
          }
          dataContent.contentArray = [];
          for (const option of options) {
            this.translateService.get(option.promo_text).subscribe((res: string) => {
              content = res;
            });
            let singleContent: NgxDialogConfig = {
              title: option.promo_title ?? null,
              content: content,
              buttons: [
                {
                  label: 'Non adesso',
                  actionType: NgxDialogButtonActionTypeENUM.CUSTOM,
                  onClick() {
                    return new Promise((resolve) => {
                      that.sendUserAction('user_experience_info', option.destination_state);
                      resolve(true);
                    });
                  }
                },
                {
                  label: 'Vai alla pagina',
                  color: 'primary',
                  actionType: 'GOTOLINK',
                  routeLink: environment.routingBasePath + '/' + option.destination_state,
                  // onClick() {
                  //   return new Promise((resolve) => {
                  //     that.router.navigateByUrl(environment.routingBasePath+'/'+option.destination_state);
                  //     resolve(true);
                  //   });
                  // }

                }
              ]
              
            }
            dataContent.contentArray.push(singleContent);
          }
          this.dialogInteractionService.openDialog(dataContent);
        }

    });

  }

  // onClosedModal() { 
  //   console.log('onClosedModal');
  // }

  checkIfAlreadyNotified(items: PromoContent[]): Promise<PromoContent[]> {
    return new Promise((resolve, reject) => {
      // this.userCompanyService.getUserCompanyInfo().then((data) => {

      this.userCompanyService.userCompany$.subscribe((data) => {
       console.log('userinfo in promoservice', data);
        let userNotifications = data.user.notificationsSubjects;
        if (userNotifications) {
          let newItems: PromoContent[] = [];
          for (const item of items) {
            if (!userNotifications.includes(item.destination_state)) {
              newItems.push(item);
            }
          }
            resolve(newItems);
        }
        resolve(items);
     
      });
    });
  }

  sendUserAction(action: string, data: any) {
     
    let wpdata = {
      meta: 'mare_notifications_subjects',
      data: data
    }
    if(window.MscActionListener) {
      window.MscActionListener.msc_listener_action(action, wpdata);
    } else {
      // this.eventInteractionService.publishData({ event: action, data: wpdata });
      this.userCompanyService.updateUserCompanyInfo('mare_notifications_subjects', data).then((data) => {
            console.log('visited pages updated', data);
          });
    }
  }

  // updateUserNotifications(menuitem: any) {
  //   this.userCompanyService.updateUserCompanyInfo('mare_visited_pages', menuitem.state).then((data) => {
  //     console.log('visited pages updated', data);
  //   });
  // }
}
